import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../Context/AppContext";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import { CategoryContext } from "./CategoryContext";
import Label from "../../Common/components/Label";
import Utils from "../../../Common/Utils";
import SkeletonElement from "./Shimmer/SkeletonElement";
import { Link, useHistory } from "react-router-dom";

let catTypeList = [];
let isSearchActive = false;

function CategoryList({ props, setApiCallDone, setCategoryDetailPageLoaded }) {
  const appData = useContext(AppContext);
  const categoryContextData = useContext(CategoryContext);
  const [loading, setLoading] = React.useState(false);
  const [categoryTypeList, setCategoryTypeList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  let itemId = "";

  const [errorMessage, setErrorMessage] = useState(null);

  const industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;

  async function load_categoriesList(showStatus = true) {
    if (showStatus) {
      setLoading(true);
    }
    let res = await ServiceWrapper.doGet(
      api_base_url + "category/getbyindustryid/" + industryId,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      await setCategoryList(res.data.data);
      await setFilteredCategories(res.data.data);
      setLoading(false);

      if (categoryContextData.editingItem != null) {
        categoryContextData.setEditingItem((prev) => ({
          type: prev.type,
          form: prev.form,
          id: prev.id,
        }));
      }

      if (
        categoryContextData.editingItem === null &&
        props.props.match.params.uid === undefined
      ) {
        setTimeout(() => {
          try {
            let createPage = false;
            if (res.data.data.length === 0) return;
            if (catTypeList.length === 0) return;
            let resutl = res.data.data.filter((item) => {
              return item.cattype === catTypeList[0].id;
            });
            categoryContextData.setCategoryType({
              type: "c",
              id: resutl[0]?.id,
            });
            if (props.props.match.params.type === "ct") {
              createPage = true;
            }

            if (props.props.match.params.type === "c") {
              createPage = true;
            }
            if (!createPage) {
              categoryContextData.setEditingItem({
                type: "c",
                form: "view",
                id: resutl[0]?.id ?? "",
              });
            }
            setApiCallDone(true);
          } catch (e) {
            console.log(e);
          }
        }, 1000);
      }
    } else {
      setLoading(false);
      setErrorMessage("Error while fetching Categories, Please refresh again!");
    }
  }

  async function load_CategoryTypes() {
    setLoading(true);

    let res = await ServiceWrapper.doGet(
      api_base_url + "categorytype/getbyindustryid/" + industryId,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      await setCategoryTypeList(res.data.data);
      // categoryContextData.setCategoryTypeList(res.data.data);
      const sortedData = res.data.data.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
      catTypeList = sortedData;
      categoryContextData.setCategoryTypeList(sortedData);
      setFilteredCategoryList(sortedData);
      setLoading(false);
    } else {
      setLoading(false);
      setErrorMessage("Error while fetching Categories, Please refresh again!");
    }
  }

  function getCategoryList(categoryTypeId) {
    return filteredCateogories.filter((item) => {
      return item.cattype === categoryTypeId;
    });
  }

  const [filteredCateogoryList, setFilteredCategoryList] = useState(categoryTypeList);
  const [filteredCateogories, setFilteredCategories] = useState(categoryList);


  async function handleSearchAttribute(value) {
    if (!Utils.isEmpty(value)) {
      const searchValue = value.toString().trim().toLowerCase();
      let updatedCategoryTypes = [];
      let updatedCategories = [];
  
      // STEP 1: First check category types
      const matchingCategoryTypes = categoryTypeList.filter(type => 
        type.name?.toLowerCase().includes(searchValue)
      );
  
      // If any category types match, include ALL their categories
      if (matchingCategoryTypes.length > 0) {
        updatedCategoryTypes = matchingCategoryTypes;
        
        // Get ALL categories belonging to matching category types
        updatedCategories = categoryList.filter(category =>
          matchingCategoryTypes.some(type => type.id === category.cattype)
        );
      }
  
      // STEP 2: Then check for matching categories
      const matchingCategories = categoryList.filter(category => 
        (category.name?.toLowerCase().includes(searchValue)) ||
        (category.description?.toLowerCase().includes(searchValue))
      );
  
      if (matchingCategories.length > 0) {
        // Get parent types of matching categories
        const parentTypes = categoryTypeList.filter(type =>
          matchingCategories.some(category => category.cattype === type.id)
        );
        
        // Combine results, avoiding duplicates
        updatedCategoryTypes = [...new Set([...updatedCategoryTypes, ...parentTypes])];
        
        // Add any matching categories that weren't already included
        const additionalCategories = matchingCategories.filter(category =>
          !updatedCategories.some(existing => existing.id === category.id)
        );
        updatedCategories = [...updatedCategories, ...additionalCategories];
      }
  
      // If no matches found in either
      if (matchingCategories.length === 0 && matchingCategoryTypes.length === 0) {
        updatedCategoryTypes = [];
        updatedCategories = [];
      }
  
      // Update state
      setFilteredCategoryList(updatedCategoryTypes);
      setFilteredCategories(updatedCategories);
      isSearchActive = updatedCategories.length > 0 || updatedCategoryTypes.length > 0;
    } else {
      // Reset to original lists if search is empty
      isSearchActive = false;
      setFilteredCategoryList(categoryTypeList);
      setFilteredCategories(categoryList);
    }
  }

  const history = useHistory();

  useEffect(() => {
    if (appData.pm.checkPermission("gmscategory_read")) {
      if (industryId) {
        load_CategoryTypes();
        load_categoriesList();
      }
    } else {
      history.push("/workspace/module/permission/denied");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industryId, categoryContextData.listReloadCounter]);

  const handleCategorySelect = (item1) => {
    if (categoryContextData?.categoryType?.id === item1?.id) return;
    categoryContextData.setCategoryType({
      type: "c",
      id: item1.id,
    });
    setCategoryDetailPageLoaded(false);
    categoryContextData.setEditingItem({
      type: "c",
      form: "view",
      id: item1.id,
    });

    // scroll the window to top on category change
    if (window) window.scrollTo(0, 0);
  };

  return (
    <React.Fragment>
      {loading && (
        <div className="px-3 h-100">
          <SkeletonElement type={"title"} />
          <br />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
        </div>
      )}

      {!loading && (
        <>
          <div className="top-0 left-0 h-0 px-2 pt-0 mt-0 col md:overflow-y-auto w-100 md:max-h-full scroll">
            <div className="flex-shrink-0 pb-0">
              <div className="p-0 px-2 pt-1">
                {categoryTypeList && categoryTypeList.length > 0 && (
                  <input
                    type="text"
                    style={{
                      fontWeight: 500,
                      fontSize: "0.8rem",
                    }}
                    onChange={(e) => handleSearchAttribute(e.target.value)}
                    className="my-2 shadow-none form-control form-control-md border-1"
                    placeholder="Search ..."
                  />
                )}
                &nbsp;
              </div>

              <div
                style={{
                  // maxHeight: "80vh",
                  overflow: "scroll",
                  paddingRight: "5px",
                }}
              >
                {!loading && !errorMessage && (
                  <ul className="list-unstyled">
                    {categoryTypeList && categoryTypeList.length > 0 ? (
                      filteredCateogoryList.map((item, index) => {
                        return (
                          <div key={index} className="">
                            <div className="gap-1 d-flex">
                              <span
                                className="btn-toggle collapsed text-truncate font-family-Noto Sans"
                                data-bs-toggle="collapse"
                                data-bs-target={`#item-${index}`}
                                aria-expanded={
                                  filteredCateogoryList.length === 1
                                    ? isSearchActive
                                    : index === 0
                                    ? true
                                    : isSearchActive
                                }
                                style={{
                                  fontFamily: "Noto Sans",
                                }}
                              />
                              <label
                                data-bs-toggle="tooltip"
                                title={item.name}
                                onClick={() => {
                                  categoryContextData.setCategoryType({
                                    type: "ct",
                                    id: item.id,
                                  });
                                  categoryContextData.setEditingItem({
                                    type: "ct",
                                    form: "view",
                                    id: item.id,
                                  });
                                }}
                                className="text-truncate"
                                style={{
                                  width: "80%",
                                  fontSize: "0.875rem",
                                  fontFamily: "Noto Sans",
                                }}
                              >
                                {item.name}
                              </label>
                            </div>
                            <div
                              className={`${
                                isSearchActive
                                  ? "collapsed"
                                  : index === 0
                                  ? "collapsed"
                                  : "collapse"
                              }`}
                              id={`item-${index}`}
                            >
                              {getCategoryList(item.id).length > 0 ? (
                                getCategoryList(item.id).map(
                                  (item1, index1) => {
                                    if (index === 0 && index1 === 0) {
                                      if (itemId !== item1.id) {
                                        itemId = item1.id;
                                      }
                                    }
                                    return (
                                      <div
                                        className="btn-toggle-nav list-unstyled w-100"
                                        key={index1}
                                      >
                                        <li>
                                          <Link
                                            data-bs-toggle="tooltip"
                                            data-placement="right"
                                            to="#"
                                            title={item1.name}
                                            onClick={() =>
                                              handleCategorySelect(item1)
                                            }
                                            className="link-dark"
                                          >
                                            &nbsp;
                                            <Label
                                              fontSize={"0.8"}
                                              message={item1.name}
                                              color={
                                                categoryContextData.editingItem &&
                                                categoryContextData.editingItem
                                                  .id === item1.id
                                                  ? "#091caa"
                                                  : "#000000"
                                              }
                                            />
                                          </Link>
                                        </li>
                                      </div>
                                    );
                                  }
                                )
                              ) : (
                                <div className="text-center d-flex justify-content-center">
                                  <div
                                    className="p-1 bg-white alert alert-primary w-75"
                                    role="alert"
                                  >
                                    No categories found
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div
                        className="p-1 bg-white alert alert-primary"
                        role="alert"
                      >
                        No categories found
                      </div>
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {!loading && errorMessage && (
        <div className="p-1 bg-white alert alert-danger small" role="alert">
          <span className="fa fa-exclamation-triangle" />
          &nbsp;&nbsp;
          <strong>{errorMessage}</strong>
        </div>
      )}
    </React.Fragment>
  );
}

export default CategoryList;
